import React, { useRef, useState } from "react";
import { useFormik } from "formik";
import { InputText } from "primereact/inputtext";
import { Button } from "primereact/button";
import { Dropdown } from "primereact/dropdown";
import { Calendar } from "primereact/calendar";
import { Divider } from "primereact/divider";
import { classNames } from "primereact/utils";
import { Card } from "primereact/card";
import { Toast } from "primereact/toast";
import { formatMoney } from "../../shared/utilitties/formatMoney";
import { ComprobanteFileUpload } from "./ComprobantesFileUpload";
import {
  actualizarFacturaPresentacion,
  crearFacturaPresentacion,
} from "../services/facturas.service";
import { FacturasIngresadaDTO } from "../adapters/factura.adapter";
import { FacturaImagenDTO } from "../adapters/facturaImagen.adapter";
import { InputNumber } from "primereact/inputnumber";
//context
import { usePresentacionContext } from "../context/presentacion.context";
//constants
import {
  FAILED_VALIDATION,
  LIFE_TOAST_MESSAGE,
  REGEX,
  SUCCESS_VALIDATION,
} from "../utilities/constants";
import {
  TOLERANCIA_DIF_IVA_PERCEPCION,
} from "../utilities/constantsImpuestos";
// css
import "./ComprobantesForm.css";
import { isCombustibleAfines } from "../utilities/utils";
import { HttpStatusCode } from "axios";
import { ParametroDTO } from "../models/parametros.model";
import '../../shared/styles/datePicker.scss'

const ENTER_KEY = "Enter";

interface Props {
  onHide: Function;
}
export const ComprobantesForm = (props: Props) => {
  const {
    presentacion,
    comprobanteSeleccionado,
    file,
    tasasIVA,
    tasaIvaSelected,
    tiposFactura,
    updateComprobantes,
    setUpdateComprobantes,
    fileName,
    setFileName,
    setFile,
    setMessage,
    setImageComprobante,
    presentacionEditable,
    selectedProductoComercio,
    parametrosPresentacion,
  } = usePresentacionContext();
  const [spinnerGuardarComprobante, setSpinnerGuardarComprobante] =
    useState(false);

  const toast = useRef<Toast>(null);

  const compRefs = {
    tipoFactura: useRef<Dropdown>(null),
    puntoVenta: useRef<HTMLInputElement>(null),
    numero: useRef<HTMLInputElement>(null),
    fecha: useRef<HTMLInputElement>(null),
    neto: useRef<HTMLInputElement>(null),
    tasas: useRef<HTMLInputElement>(null),
    iva_inp: useRef<HTMLInputElement>(null),
    iva_perc: useRef<HTMLInputElement>(null),
    ibb: useRef<HTMLInputElement>(null),
    total: useRef<HTMLInputElement>(null),
    iva_dropdw: useRef<Dropdown>(null)
  };

  const tasaIvaFilter =
    JSON.stringify(comprobanteSeleccionado) !== "{}"
      ? tasasIVA.filter(
        (item: any) => item.tasa == comprobanteSeleccionado.fac_tasa_iva
      )
      : [];
  const tiposFacturaFilter =
    JSON.stringify(comprobanteSeleccionado) !== "{}"
      ? tiposFactura.filter(
        (item: any) =>
          item.fat_descripcion_corta ===
          comprobanteSeleccionado.fat_descripcion_red
      )
      : [];
  const formik = useFormik({
    initialValues: {
      fat_descripcion_red:
        tiposFacturaFilter.length > 0 ? tiposFacturaFilter[0] : [],
      fac_tipo_comprobante:
        JSON.stringify(comprobanteSeleccionado) !== "{}"
          ? comprobanteSeleccionado.fac_tipo_comprobante
          : tasasIVA[0].tipo_comprobante!= "N" ? tasasIVA[0].tipo_comprobante : "A",
      Fac_sucursal: comprobanteSeleccionado.fac_sucursal,
      Fac_numero: comprobanteSeleccionado.fac_numero,
      Fecha:
        comprobanteSeleccionado.fac_fecha &&
        new Date(comprobanteSeleccionado.fac_fecha),
      Fac_neto:
        comprobanteSeleccionado.fac_neto ?
          parseFloat(comprobanteSeleccionado.fac_neto) : 0,
      Fac_impuestos:
        comprobanteSeleccionado.fac_impuestos ?
          parseFloat(comprobanteSeleccionado.fac_impuestos) : 0,
      Fac_iva:
        comprobanteSeleccionado.fac_iva ?
          parseFloat(comprobanteSeleccionado.fac_iva) : 0,
      Fac_iva_percepcion:
        comprobanteSeleccionado.fac_iva_percepcion ?
          parseFloat(comprobanteSeleccionado.fac_iva_percepcion) : 0,
      Fac_IIBB_percepcion:
        comprobanteSeleccionado.fac_IIBB_percepcion ?
          parseFloat(comprobanteSeleccionado.fac_IIBB_percepcion) : 0,
      Fac_total:
        comprobanteSeleccionado.fac_total ?
          parseFloat(comprobanteSeleccionado.fac_total) : 0,
      Fac_tasa_iva: tasaIvaFilter.length > 0 ? tasaIvaFilter[0] : [],
    },
    validate: (data) => {
      let errors: any = {};
      if (data.fat_descripcion_red.length === 0) {
        errors.fat_descripcion_red = "Requerido.";
      }
      if (!data.fac_tipo_comprobante) {
        errors.comprobante = "Requerido.";
      }
      if (!data.Fac_sucursal) {
        errors.Fac_sucursal = "Requerido.";
      }
      if (!data.Fac_numero) {
        errors.Fac_numero = "Requerido.";
      }

      if (data.Fac_neto == 0 || data.Fac_neto == null) {
        errors.Fac_neto = "Requerido.";
      }

      if (data.Fac_impuestos !== 0) {
        if (!data.Fac_impuestos) {
          errors.Fac_impuestos = "Requerido.";
        }
      }
      if (data.Fac_iva !== 0) {
        if (!data.Fac_iva) {
          errors.Fac_iva = "Requerido.";
        }
      }
      
      if (data.Fac_total == 0 || data.Fac_total == null ) {
        errors.Fac_total = "Requerido.";
      }
      if (data.Fac_tasa_iva.length === 0) {
        errors.Fac_tasa_iva = "Requerido.";
      }
      return errors;
    },
    onSubmit: async (formData: any) => {
      const resultValidaciones = validaciones(formData);
      if (resultValidaciones.message === FAILED_VALIDATION) return;
      let facturasIngresadaDTO = FacturasIngresadaDTO(formData, presentacion);
      let facturaImagenDto = FacturaImagenDTO();
      let facturasPresentacionRequest = {
        factura: facturasIngresadaDTO,
        imagenFactura: facturaImagenDto,
      };
      if (fileName && file) {
        let fileBase64 = file?.replace(REGEX, "");
        let facturaImagenDto = FacturaImagenDTO(fileName, fileBase64);
        facturasPresentacionRequest.imagenFactura = facturaImagenDto;
      }
      setSpinnerGuardarComprobante(true);
      if (JSON.stringify(comprobanteSeleccionado) === "{}") {
        const {data, status} = await crearFacturaPresentacion(facturasPresentacionRequest);
        if (typeof data === 'string') {
              toast.current?.show({
                life: LIFE_TOAST_MESSAGE,
                severity: "error",
                summary: "Error del Sistema",
                detail: data.includes('Request Rejected') 
                  ? "La operación fue bloqueada por seguridad. Contacte al administrador."
                  : "Se recibió una respuesta inválida del servidor",
              });
              setSpinnerGuardarComprobante(false);
              return { message: FAILED_VALIDATION };
            }
        if (status != HttpStatusCode.Ok) {
          toast.current?.show({
            life: LIFE_TOAST_MESSAGE,
            severity: status == HttpStatusCode.InternalServerError ? "error" : "warn",
            summary: "Message",
            detail: data.message != null && data.message != '' ? data.message : "Hubo un error al crear el comprobante",
          });

          setSpinnerGuardarComprobante(false);
          return { message: FAILED_VALIDATION };
        }

        setMessage({
          life: 5000,
          severity: "success",
          summary: "Message",
          detail: "Comprobante registrado.",
        });

        setUpdateComprobantes(updateComprobantes + 1);

      } else {
        facturasPresentacionRequest.factura.Fac_id =comprobanteSeleccionado.fac_id;
        facturasPresentacionRequest.factura.Fpa_nombre_imagen =comprobanteSeleccionado.fpa_nombre_imagen;

        const {data, status} = await actualizarFacturaPresentacion(facturasPresentacionRequest);
         if (typeof data === 'string') {
              toast.current?.show({
                life: LIFE_TOAST_MESSAGE,
                severity: "error",
                summary: "Error del Sistema",
                detail: data.includes('Request Rejected') 
                  ? "Ocurrió un error en el proceso, vuelva a intentar más tarde. Si el error persiste, contacte al administrador."
                  : "Ocurrió un error en la lectura, vuelva a intentar más tarde.",
              });
              setSpinnerGuardarComprobante(false);
              return { message: FAILED_VALIDATION };
            }
        let msgUpd: string = ''
        if(status == HttpStatusCode.Ok){
          msgUpd= "Comprobante actualizado" 
        }
        else if(data.message != null && data.message != ''){
          data.message.indexOf('Cannot insert duplicate key') > 0 
          ? msgUpd = "El comprobante ya se encuentra cargado para ese comercio."
          : msgUpd ="Hubo un error al actualizar.";
        }else {
          msgUpd ="Hubo un error al actualizar.";
        } 
        setMessage({
          life: 5000,
          severity: status == HttpStatusCode.Ok ? "success" : "error",
          summary: "Message",
          detail:  msgUpd
        });
        setUpdateComprobantes(updateComprobantes + 1)
      }
      setSpinnerGuardarComprobante(false);
      onHideDialog();
    },
  });

  const validaciones = (data: any) => {
    let facTotal = parseFloat(data.Fac_total);
    let facNeto = parseFloat(data.Fac_neto);
    let facIva = parseFloat(data.Fac_iva);
    let facImpuestos = parseFloat(data.Fac_impuestos);
    let facTasaIva = parseFloat(data.Fac_tasa_iva.tasa);
    let facIvaPercepcion = parseFloat(data.Fac_iva_percepcion);
    let facIIBBPercepcion = parseFloat(data.Fac_IIBB_percepcion);

    let message = SUCCESS_VALIDATION;
    //ToleranciaTopeIva 23
    let toleranciaTopeIva =  parametrosPresentacion.filter((item:ParametroDTO) => item.subcodigo == "ToleranciaTopeIva")
    const TOLERANCIA_TOPE_IVA = Number.isNaN(Number.parseFloat(toleranciaTopeIva[0].valor)) ? 0 : parseFloat(toleranciaTopeIva[0].valor)

    let totalNetoImpuesto = facNeto + facImpuestos;
    if (totalNetoImpuesto < TOLERANCIA_TOPE_IVA && facIvaPercepcion > 0) {
      toast.current?.show({
        life: LIFE_TOAST_MESSAGE,
        severity: "warn",
        summary: "Message",
        detail:
          "Si el neto es menor a $ " +
          TOLERANCIA_TOPE_IVA +
          ", no debe ingresar percepcion de Iva",
      });
      return { message: FAILED_VALIDATION };
    }

    //12 $2
    //calcula el 3% del neto y hago la diferencia entre ivapercepcion- porcentajeNeto
    let difIvaPer =  parametrosPresentacion.filter((item:ParametroDTO) => item.subcodigo == "DiferenciaPerIvaYCalPercepcion")
    const DIFERENCIAPERIVAYCALPERCEPCION = Number.isNaN(Number.parseFloat(difIvaPer[0].valor)) ? 0 : parseFloat(difIvaPer[0].valor)

    let resultIvaPer =  parametrosPresentacion.filter((item:ParametroDTO) => item.subcodigo == "IvaPercepcion")
    const IVA_PERCEPCION = Number.isNaN(Number.parseFloat(resultIvaPer[0].valor)) ? 0 : parseFloat(resultIvaPer[0].valor)
    let porcentajeNeto = Number(facNeto * IVA_PERCEPCION).toFixed(2);
    let diferenciaPerIvaYCalPercepcion = facIvaPercepcion - parseFloat(porcentajeNeto);
    
    if (Math.abs(diferenciaPerIvaYCalPercepcion) > DIFERENCIAPERIVAYCALPERCEPCION && facIvaPercepcion > 0) {
      toast.current?.show({
        life: LIFE_TOAST_MESSAGE,
        severity: "warn",
        summary: "Message",
        detail:
          "La diferencia permitida entre la percepcion de IVA ingresado y el " +
          IVA_PERCEPCION +
          " % del neto es $" +
          DIFERENCIAPERIVAYCALPERCEPCION +
          ". Total Diferencia: $" +
          formatMoney(diferenciaPerIvaYCalPercepcion),
      });
      return { message: FAILED_VALIDATION };
    }

    if (facIvaPercepcion > parseFloat(porcentajeNeto) && Math.abs(diferenciaPerIvaYCalPercepcion) > TOLERANCIA_DIF_IVA_PERCEPCION) {
      toast.current?.show({
        life: LIFE_TOAST_MESSAGE,
        severity: "warn",
        summary: "Message",
        detail: `La percepcion supera el ${IVA_PERCEPCION}% del neto`,
      });
      return { message: FAILED_VALIDATION };
    }
    //17 $
    let toleranciaImpTasaFC =  parametrosPresentacion.filter((item:ParametroDTO) => item.subcodigo == "ToleranciaImporteTasaCargaFC")
    const TOLERANCIA_IMPORTE_TASA_CARGAFC = Number.isNaN(Number.parseFloat(toleranciaImpTasaFC[0].valor)) ? 0 : parseFloat(toleranciaImpTasaFC[0].valor)

    let ivaCalculado = Number((facNeto * facTasaIva) / 100).toFixed(3);
    let diferenciaImporteTasaCargaFC = Number(parseFloat(ivaCalculado) - facIva).toFixed(2);
    if (Math.abs(parseFloat(diferenciaImporteTasaCargaFC)) > TOLERANCIA_IMPORTE_TASA_CARGAFC) {
      toast.current?.show({
        life: LIFE_TOAST_MESSAGE,
        severity: "warn",
        summary: "Message",
        detail:
          "La diferencia permitida entre el importe de IVA calculado y el importe IVA ingresado es $" +
          formatMoney(TOLERANCIA_IMPORTE_TASA_CARGAFC) +
          ". Total Diferencia: $" +
          formatMoney(diferenciaImporteTasaCargaFC),
      });
      return { message: FAILED_VALIDATION };
    }

    //22 %
    let toleranciaTasaFC =  parametrosPresentacion.filter((item:ParametroDTO) => item.subcodigo == "ToleranciaTasaCargaFC")
    const TOLERANCIA_TASA_CARGAFC = Number.isNaN(Number.parseFloat(toleranciaTasaFC[0].valor)) ? 0 : parseFloat(toleranciaTasaFC[0].valor)
    let tasaIvaCalculado = Number((parseFloat(ivaCalculado) * 100) / facNeto);
    let diferenciaTasaIva = tasaIvaCalculado - facTasaIva;
    //Math.abs(x)
    if (Math.abs(diferenciaTasaIva) > TOLERANCIA_TASA_CARGAFC) {
      toast.current?.show({
        life: LIFE_TOAST_MESSAGE,
        severity: "warn",
        summary: "Message",
        detail:
          "La diferencia de porcentaje permitida entre la Tasa de IVA calculada y la Ingresada es % " +
          TOLERANCIA_TASA_CARGAFC +
          ". Total Diferencia: $" +
          formatMoney(diferenciaTasaIva),
      });
      return { message: FAILED_VALIDATION };
    }

    //18 %
    if(isCombustibleAfines(selectedProductoComercio.grupoProductoId)){

      let toleranciaImpFC =  parametrosPresentacion.filter((item:ParametroDTO) => item.subcodigo == "ToleranciaImpuestosCargaFC")
      const TOLERANCIA_IMPUESTOS_CARGAFC = Number.isNaN(Number.parseFloat(toleranciaImpFC[0].valor)) ? 0 : parseFloat(toleranciaImpFC[0].valor)
      
      let porcentajeImpuestosCargaFC =
      (parseFloat(data.Fac_impuestos) * 100) / parseFloat(data.Fac_neto);
      if (porcentajeImpuestosCargaFC > TOLERANCIA_IMPUESTOS_CARGAFC) {
        toast.current?.show({
          life: LIFE_TOAST_MESSAGE,
          severity: "warn",
          summary: "Message",
          detail:
          "La diferencia de porcentaje permitida entre importe de impuestos con respecto al importe neto es % " +
          TOLERANCIA_IMPUESTOS_CARGAFC +
          " Total Diferencia: %" +
          porcentajeImpuestosCargaFC,
        });
        return { message: FAILED_VALIDATION };
      }
    }

    //21 %

    let totalPercepciones = Number(
      facIvaPercepcion + facIIBBPercepcion
    ).toFixed(2);
    let totalNetoEImpuestos = Number(facNeto + facImpuestos).toFixed(2);

    //let totalImpuestos = Number(neto + iva + impuestos)
    //let tasaPercepciones = Number((parseFloat(totalPercepciones) * 100)/ parseFloat(totalNetoEImpuestos)).toFixed(2)
    let toleranciaPercepciones =  parametrosPresentacion.filter((item:ParametroDTO) => item.subcodigo == "ToleranciaPercepciones")
    const TOLERANCIA_PERCEPCIONES = Number.isNaN(Number.parseFloat(toleranciaPercepciones[0].valor)) ? 0 : parseFloat(toleranciaPercepciones[0].valor)
     

    let tasaPercepciones = Number(
      (parseFloat(totalPercepciones) * 100) / parseFloat(totalNetoEImpuestos)
    ).toFixed(2);

    if (parseFloat(tasaPercepciones) / 100 > TOLERANCIA_PERCEPCIONES) {
      toast.current?.show({
        life: LIFE_TOAST_MESSAGE,
        severity: "warn",
        summary: "Message",
        detail:
          "La diferencia permitida entre percepciones con respecto al neto mas impuestos es % " +
          TOLERANCIA_PERCEPCIONES +
          " Total Diferencia: % " +
          formatMoney(tasaPercepciones),
      });
      return { message: FAILED_VALIDATION };
    }

    //20 $
    //validaciones
    //consultar diego decimal valor_total = Math.Round(neto + iva + impuesto + ivaPercepcion + iibbPercep + redondeo, 2);
    let tolMontoCargaFC =  parametrosPresentacion.filter((item:ParametroDTO) => item.subcodigo == "ToleranciaMontoCargaFC")
    const TOLERANCIA_MONTO_CARGAFC = Number.isNaN(Number.parseFloat(tolMontoCargaFC[0].valor)) ? 0 : parseFloat(tolMontoCargaFC[0].valor)

    let totalImpuestos = Number(
      facNeto + facIva + facImpuestos + facIvaPercepcion + facIIBBPercepcion
    ).toFixed(2);
    let ToleranciaMontoCargaFC = Number(facTotal - parseFloat(totalImpuestos));
    if (Math.abs(ToleranciaMontoCargaFC) > TOLERANCIA_MONTO_CARGAFC) {
      toast.current?.show({
        life: LIFE_TOAST_MESSAGE,
        severity: "warn",
        summary: "Message",
        detail:
          "La diferencia permitida entre el total facturado y el neto mas iva e impuestos es $" +
          formatMoney(TOLERANCIA_MONTO_CARGAFC) +
          ", " +
          "Total Diferencia: $" +
          formatMoney(ToleranciaMontoCargaFC),
      });
      return { message: FAILED_VALIDATION };
    }

    return { message };
  };

  const formikTouched: any = formik.touched;
  const formikErrors: any = formik.errors;

  const isFormFieldValid = (name: string) =>
    !!(formikTouched[name] && formikErrors[name]);
  const getFormErrorMessage = (name: string) => {
    return (
      isFormFieldValid(name) && (
        <small className="p-error">{formikErrors[name]}</small>
      )
    );
  };

  const onHideDialog = () => {
    setFileName("");
    formik.resetForm();
    setImageComprobante({});
    props.onHide();
    //setFile()
  };

  const handlerEnterKey: (event: { key: string, preventDefault: () => any, stopPropagation: () => any }, submit: boolean, next: React.RefObject<HTMLInputElement | Dropdown> | null) => void = (e, submit, next) => {
    if (e.key !== ENTER_KEY) return;

    if (submit) {
      e.stopPropagation();
      formik.handleSubmit();
      return;
    }

    if (next == null || next.current == null) return;

    e.preventDefault();
    e.stopPropagation();

    if(next.current instanceof HTMLInputElement) {
      next.current.focus();
      return;
    }

    next.current.getFocusInput().focus();
  }

  const handleBlur = (name: string, e: any) => {
    let totalFormat = Number(
      parseFloat(e.currentTarget.value ? e.currentTarget.value : 0)
    ).toFixed(2);
    formik.setFieldValue(name, totalFormat);
  };

  const subtitleCard = (subtitle: string) => {
    return <span style={{ fontWeight: 600 }}>{subtitle}</span>;
  };

  return (
    <div className="form-demo comprobantes">
      <Toast ref={toast} position="bottom-right" />
      <form onSubmit={formik.handleSubmit} className="flex p-fluid justify-content-center">
        <Card
          subTitle={() => subtitleCard("DATOS DE COMPROBANTE")}
          className="p-mb-2"
        >
          <div className="p-grid p-fluid  p-align-baseline comprobantes-grid-datos-generales">
            <div className="p-col-12 p-md-3">
              <div className="field">
                <span className="p-float-label">
                  <Dropdown
                    onKeyDown={(e) => handlerEnterKey(e, false, compRefs.puntoVenta)}
                    id="fat_descripcion_red"
                    name="fat_descripcion_red"
                    value={formik.values.fat_descripcion_red}
                    onChange={formik.handleChange}
                    options={tiposFactura}
                    optionLabel="fat_descripcion"
                    disabled={!presentacionEditable}
                  />
                  <label htmlFor="fat_descripcion_red">Tipo*</label>
                </span>
                {getFormErrorMessage("fat_descripcion_red")}
              </div>
            </div>
            <div className="p-col-12 p-md-2">
              <div className="field">
                <span className="p-float-label">
                  <InputText
                    id="fac_tipo_comprobante"
                    name="fac_tipo_comprobante"
                    value={formik.values.fac_tipo_comprobante}
                    onChange={formik.handleChange}
                    disabled={true}
                    className={classNames({
                      "p-invalid": isFormFieldValid("fac_tipo_comprobante"),
                    })}
                  />
                  <label
                    htmlFor="fac_tipo_comprobante"
                    className={classNames({
                      "p-error": isFormFieldValid("fac_tipo_comprobante"),
                    })}
                  >
                    Letra
                  </label>
                </span>
                {getFormErrorMessage("fac_tipo_comprobante")}
              </div>
            </div>
            <div className="p-col-12 p-md-2">
              <div className="field">
                <span className="p-float-label">
                  <InputText
                    onKeyDown={(e) => handlerEnterKey(e, false, compRefs.numero)}
                    ref={compRefs.puntoVenta}
                    id="Fac_sucursal"
                    name="Fac_sucursal"
                    value={formik.values.Fac_sucursal}
                    onChange={formik.handleChange}
                    autoFocus
                    disabled={!presentacionEditable}
                    className={classNames({
                      "p-invalid": isFormFieldValid("Fac_sucursal"),
                    })}
                  />
                  <label
                    htmlFor="Fac_sucursal"
                    className={classNames({
                      "p-error": isFormFieldValid("Fac_sucursal"),
                    })}
                  >
                    Punto de venta*
                  </label>
                </span>
                {getFormErrorMessage("Fac_sucursal")}
              </div>
            </div>
            <div className="p-col-12 p-md-2">
              <div className="field">
                <span className="p-float-label">
                  <InputText
                    onKeyDown={(e) => handlerEnterKey(e, false, compRefs.fecha)}
                    ref={compRefs.numero}
                    id="Fac_numero"
                    name="Fac_numero"
                    value={formik.values.Fac_numero}
                    onChange={formik.handleChange}
                    disabled={!presentacionEditable}
                    className={classNames({
                      "p-invalid": isFormFieldValid("Fac_numero"),
                    })}
                  />
                  <label
                    htmlFor="Fac_numero"
                    className={classNames({
                      "p-error": isFormFieldValid("Fac_numero"),
                    })}
                  >
                    Numero*
                  </label>
                </span>
                {getFormErrorMessage("Fac_numero")}
              </div>
            </div>

            <div className="p-col-12 p-md-3">
              <div className="field">
                <span className="p-float-label">
                  <Calendar
                    inputRef={compRefs.fecha}
                    onSelect={e => handlerEnterKey({ key: ENTER_KEY, preventDefault: () => { }, stopPropagation: () => { } }, false, compRefs.neto)}
                    id="Fecha"
                    name="Fecha"
                    value={formik.values.Fecha}
                    onChange={formik.handleChange}
                    dateFormat="dd/mm/yy"
                    mask="99/99/9999"
                    showIcon
                    disabled={!presentacionEditable}
                    maxDate={new Date()}
                  />
                  <label htmlFor="Fecha">Fecha</label>
                </span>
              </div>
            </div>
          </div>
        </Card>
        <Card subTitle={() => subtitleCard("DETALLE")} className="p-mb-2">
          <div className="p-grid p-align-baseline comprobantes-grid-impuestos">
            <div className="p-grid p-col p-lg-11 p-md-10 p-sm-8">
              <div className="p-p-2 p-col p-lg-2 p-md-4 p-sm-6" >
                <div className="field">
                  <span className="p-float-label">
                    <InputNumber
                      onKeyDown={(e) => handlerEnterKey(e, false, compRefs.tasas)}
                      inputRef={compRefs.neto}
                      id="Fac_neto"
                      name="Fac_neto"
                      value={formik.values.Fac_neto}
                      onValueChange={(e) =>
                        formik.setFieldValue("Fac_neto", e.value)
                      }
                      mode="decimal"
                      minFractionDigits={2}
                      min={0}
                      disabled={!presentacionEditable}
                      className={classNames({
                        "p-invalid": isFormFieldValid("Fac_neto"),
                      })}
                    />

                    <label
                      htmlFor="Fac_neto"
                      className={classNames({
                        "p-error": isFormFieldValid("Fac_neto"),
                      })}
                    >
                      Neto*
                    </label>
                  </span>
                  {getFormErrorMessage("Fac_neto")}
                </div>
              </div>
              <div className="p-p-2 p-col p-lg-2 p-md-4 p-sm-6">
                <div className="field">
                  <span className="p-float-label">
                    <InputNumber
                      onKeyDown={(e) => handlerEnterKey(e, false, compRefs.iva_inp)}
                      inputRef={compRefs.tasas}
                      id="Fac_impuestos"
                      name="Fac_impuestos"
                      value={formik.values.Fac_impuestos}
                      onValueChange={(e) =>
                        formik.setFieldValue("Fac_impuestos", e.value)
                      }
                      mode="decimal"
                      minFractionDigits={2}
                      min={0}
                      disabled={!presentacionEditable}
                      className={classNames({
                        "p-invalid": isFormFieldValid("Fac_impuestos"),
                      })}
                    />
                    <label
                      htmlFor="Fac_impuestos"
                      className={classNames({
                        "p-error": isFormFieldValid("Fac_impuestos"),
                      })}
                    >
                      {isCombustibleAfines(selectedProductoComercio.grupoProductoId)
                        ? "ITC/IDC/Tasas*"
                        : "Neto No Gravado*"}
                    </label>
                  </span>
                  {getFormErrorMessage("Fac_impuestos")}
                </div>
              </div>
              <div className="p-p-2 p-col p-lg-2 p-md-4 p-sm-6">
                <div className="field">
                  <span className="p-float-label">
                    <InputNumber
                      onKeyDown={(e) => handlerEnterKey(e, false, compRefs.iva_perc)}
                      inputRef={compRefs.iva_inp}
                      id="Fac_iva"
                      name="Fac_iva"
                      value={formik.values.Fac_iva}
                      onValueChange={(e) =>
                        formik.setFieldValue("Fac_iva", e.value)
                      }
                      mode="decimal"
                      minFractionDigits={2}
                      min={0}
                      disabled={!presentacionEditable}
                      className={classNames({
                        "p-invalid": isFormFieldValid("Fac_iva"),
                      })}
                    />
                    <label
                      htmlFor="Fac_iva"
                      className={classNames({
                        "p-error": isFormFieldValid("Fac_iva"),
                      })}
                    >
                      IVA*
                    </label>
                  </span>
                  {getFormErrorMessage("Fac_iva")}
                </div>
              </div>
              <div className="p-p-2 p-col p-lg-2 p-md-4 p-sm-6">
                <div className="field">
                  <span className="p-float-label">
                    <InputNumber
                      onKeyDown={(e) => handlerEnterKey(e, false, compRefs.ibb)}
                      inputRef={compRefs.iva_perc}
                      id="Fac_iva_percepcion"
                      name="Fac_iva_percepcion"
                      value={formik.values.Fac_iva_percepcion}
                      onValueChange={(e) =>
                        formik.setFieldValue("Fac_iva_percepcion", e.value)
                      }
                      mode="decimal"
                      minFractionDigits={2}
                      min={0}
                      disabled={!presentacionEditable}
                      className={classNames({
                        "p-invalid": isFormFieldValid("Fac_iva_percepcion"),
                      })}
                    />
                    <label
                      htmlFor="Fac_iva_percepcion"
                      className={classNames({
                        "p-error": isFormFieldValid("Fac_iva_percepcion"),
                      })}
                    >
                      IVA percepción*
                    </label>
                  </span>
                  {getFormErrorMessage("Fac_iva_percepcion")}
                </div>
              </div>
              <div className="p-p-2 p-col p-lg-2 p-md-4 p-sm-6">
                <div className="field">
                  <span className="p-float-label">
                    <InputNumber
                      onKeyDown={(e) => handlerEnterKey(e, false, compRefs.total)}
                      inputRef={compRefs.ibb}
                      id="Fac_IIBB_percepcion"
                      name="Fac_IIBB_percepcion"
                      value={formik.values.Fac_IIBB_percepcion}
                      onValueChange={(e) =>
                        formik.setFieldValue("Fac_IIBB_percepcion", e.value)
                      }
                      mode="decimal"
                      minFractionDigits={2}
                      min={0}
                      disabled={!presentacionEditable}
                      className={classNames({
                        "p-invalid": isFormFieldValid("Fac_IIBB_percepcion"),
                      })}
                    />
                    <label
                      htmlFor="Fac_IIBB_percepcion"
                      className={classNames({
                        "p-error": isFormFieldValid("Fac_IIBB_percepcion"),
                      })}
                    >
                      IIBB percepción*
                    </label>
                  </span>
                  {getFormErrorMessage("Fac_IIBB_percepcion")}
                </div>
              </div>
              <div className="p-p-2 p-col p-lg-2 p-md-4 p-sm-6">
                <div className="field">
                  <span className="p-float-label">
                    <InputNumber
                      onKeyDown={(e) => handlerEnterKey(e, false, compRefs.iva_dropdw)}
                      inputRef={compRefs.total}
                      id="Fac_total"
                      name="Fac_total"
                      value={formik.values.Fac_total}
                      onValueChange={(e) =>
                        formik.setFieldValue("Fac_total", e.value)
                      }
                      mode="decimal"
                      minFractionDigits={2}
                      min={0}
                      disabled={!presentacionEditable}
                      className={classNames({
                        "p-invalid": isFormFieldValid("Fac_total"),
                      })}
                    />
                    <label
                      htmlFor="Fac_total"
                      className={classNames({
                        "p-error": isFormFieldValid("Fac_total"),
                      })}
                    >
                      Total*
                    </label>
                  </span>
                  {getFormErrorMessage("Fac_total")}
                </div>
              </div>
            </div>
            <div className="p-p-2 p-col p-lg-1 p-md-2 p-sm-4">
              <div className="field">
                <span className="p-float-label drop-arrow">
                  <Dropdown
                    onKeyDown={(e) => handlerEnterKey(e, true, null)}
                    ref={compRefs.iva_dropdw}
                    id="Fac_tasa_iva"
                    name="Fac_tasa_iva"
                    value={formik.values.Fac_tasa_iva}
                    onChange={formik.handleChange}
                    options={
                      tasaIvaSelected
                        ? tasasIVA.filter(
                          (item: any) => item.tasa == tasaIvaSelected
                        )
                        : tasasIVA
                    }
                    optionLabel="tasa"
                    disabled={!presentacionEditable}
                  />
                  <label htmlFor="Fac_tasa_iva">IVA % </label>
                </span>
                {getFormErrorMessage("Fac_tasa_iva")}
              </div>
            </div>
          </div>
        </Card>
        <Card
          subTitle={() => subtitleCard("CARGAR ARCHIVO")}
          className="comprobante-fileupload"
        >
          <ComprobanteFileUpload />
        </Card>
        <Divider />
        {presentacionEditable && (
          <div className="p-grid p-fluid  p-align-baseline p-jc-end">
            <div className="p-col-12 p-md-4">
              <div className="button-demo">
                <div className="template">
                  <Button
                    type="button"
                    className="delete p-0"
                    aria-label="Discord"
                    style={{ minWidth: "150px" }}
                    onClick={() => props.onHide()}
                  >
                    <i className="pi pi-times px-2"></i>
                    <span className="px-3">Cancelar</span>
                  </Button>
                </div>
              </div>
            </div>
            <div className="p-col-12 p-md-4">
              <div className="button-demo">
                <div className="template">
                  <Button
                    className="twitter p-0"
                    aria-label="Twitter"
                    type="submit"
                    onSubmit={e => formik.handleSubmit()}
                    style={{ minWidth: "150px" }}
                  >
                    {spinnerGuardarComprobante ? (
                      <div
                        style={{ width: "38px", backgroundColor: "#3b82f6" }}
                      >
                        <i className="pi pi-spin pi-spinner"></i>
                      </div>
                    ) : (
                      <i className="pi pi-check px-2"></i>
                    )}
                    <span className="px-3">Guardar</span>
                  </Button>
                </div>
              </div>
            </div>
          </div>
        )}
      </form>
    </div>
  );
};
